export const accountComponents = {
  // OtaLinksBar.vue — OTA links bar
  otaLinks: {
    copied: "Copié !",
    copy: "Copier",
    edit: "Modifier",
    remove: "Supprimer",
    addLink: "Lien OTA",
    modalEyebrow: "Lien de l'annonce sur l'OTA",
    modalEyebrowUnit: "Lien de cette unité sur l'OTA",
    editTitle: "Modifier le lien",
    addTitle: "Ajouter un lien OTA",
    modalHint: "Collez l'URL publique de <b>cette annonce</b> sur l'OTA. Cela vous permet de la copier et de l'ouvrir rapidement.",
    urlLabel: "URL de l'annonce",
    cancel: "Annuler",
    saving: "Enregistrement…",
    save: "Enregistrer le lien",
    saveError: "Impossible d'enregistrer le lien. Vérifiez l'URL.",
    fromListing: "de l'annonce",
    inheritedNote: "C'est le lien de l'annonce. Tant que cette unité n'a pas le sien, c'est celui que nous envoyons.",
    override: "Définir le sien",
    modalHintUnit: "Collez l'URL publique de <b>cette unité</b> sur l'OTA. Si vous la renseignez, c'est elle qui est envoyée ; sinon, c'est celle de l'annonce.",
  },

  // GuestJourneySimulator.vue — guest journey simulator
  journeySim: {
    title: "Simuler le parcours client",
    badge: "Test",
    intro: "Rejouez tout le processus —de la réservation à l'avis— dans une conversation WhatsApp. Saisissez un nom et un numéro, puis appuyez sur <strong>lecture</strong>. Si vous activez «Envoyer sur mobile», chaque message est réellement envoyé au numéro pour que vous puissiez l'essayer et discuter avec l'agent IA.",
    guestNameLabel: "Nom du client",
    guestNamePlaceholder: "ex. Laura García",
    phoneLabel: "Numéro WhatsApp (pour le test)",
    phoneHint: "Format international, ex. +34 600123456",
    toggleTitle: "Envoyer aussi sur mobile",
    toggleDesc: "Chaque étape est réellement envoyée au numéro ci-dessus",
    warn: "Envoyez d'abord «bonjour» au numéro depuis votre téléphone pour ouvrir la fenêtre de 24 h de WhatsApp ; ainsi, vous recevrez les messages instantanément.",
    reset: "Redémarrer",
    prev: "Précédent",
    pause: "Pause",
    play: "Lecture",
    continue: "Continuer",
    next: "Suivant",
    stepProgress: "Étape {current} sur {total}",
    guestFallback: "Client",
    propertyFallback: "votre hébergement",
    testNumberFallback: "numéro de test",
    dayLabel: "Parcours client",
    loadingMsgs: "Chargement de vos messages…",
    pressPlay: "Appuyez sur <strong>Lecture</strong> pour démarrer le parcours ▶",
    hintSending: "Envoi en direct activé · chaque étape atteint {phone}",
    hintSimulated: "Vue simulée · activez «Envoyer sur mobile» pour tester sur un vrai téléphone",
    toastInvalidPhone: "Saisissez un numéro WhatsApp valide pour envoyer sur mobile.",
    toastSendFailed: "Échec de l'envoi.",
    toastSendMobileFailed: "Impossible d'envoyer sur mobile.",
    // Simulated WhatsApp messages ({{...}} are resolved by resolve())
    msgConfirmation: "Bonjour *{{nombre_huesped}}* 👋\n\nVotre réservation à *{{nombre_alojamiento}}* est confirmée ✅\n\nCode de réservation : *6233Q1VC5*\nDates : *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nVia ce WhatsApp, vous pouvez demander votre lien de check-in en ligne et recevoir les instructions d'arrivée.",
    msgCheckinPrompt: "*Bonjour* 👋 Je suis l'assistant virtuel de *{{nombre_alojamiento}}*.\n\nAppuyez sur *Ok* pour poursuivre votre check-in.",
    msgChooseLanguage: "Elige tu idioma · Choose your language",
    msgCheckinLink: "*Merci* 👋 Voici votre lien pour effectuer le check-in 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 Bienvenue à *{{nombre_alojamiento}}*, {{nombre_huesped}} !\n\nMerci d'avoir finalisé votre enregistrement. Voici toutes les informations concernant votre séjour.",
    msgAccess: "🔒🔑 *Code d'accès · {{nombre_alojamiento}}*\n\nVotre code est : *58117*\n\nValable pendant tout votre séjour.",
    msgArrival: "🏡 *Instructions d'arrivée*\n\nÀ votre arrivée, dirigez-vous vers l'entrée principale et saisissez votre code sur la serrure. 🔑\n\nProfitez bien de votre séjour ! ✨",
    msgGuestCheckout: "Bonjour, à quelle heure est le check-out ?",
    msgCheckoutReply: "Bonjour ! Le check-out est jusqu'à *12:00* 🕚 Si vous devez partir plus tard, je peux étudier un check-out tardif pour vous 😊",
    msgCheckout: "Bonjour *{{nombre_huesped}}* 👋\n\nPetit rappel : *votre séjour se termine demain* à *{{nombre_alojamiento}}*.\n\n🕚 L'heure limite de check-out est *{{hora_salida}}*.\n\nMerci beaucoup pour votre visite et bon voyage ! 😊",
    msgReview: "⭐ Comment s'est passé votre séjour à *{{nombre_alojamiento}}*, {{nombre_huesped}} ?\n\nNous aimerions beaucoup avoir votre avis. Laissez-nous votre avis ici 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — guest journey timeline
  journeyTimeline: {
    title: "Parcours client",
    subtitle: "De la réservation au départ. Survolez chaque événement pour voir le message.",
    disabled: "Désactivé",
    clickToConfigure: "Cliquez pour configurer",
    nameFallback: "votre hébergement",
    // Node labels
    labelLead: "Réservation / Prospect",
    labelConfirm: "Confirmation",
    labelCheckinLink: "Lien de check-in",
    labelWelcome: "Bienvenue",
    labelAccess: "Accès / Serrure",
    labelArrival: "Instructions d'arrivée",
    labelCheckout: "Message de départ",
    labelReview: "Avis",
    // Timing of each node
    whenLead: "À la réservation ou à l'envoi d'un message",
    whenConfirm: "Réservation confirmée",
    whenCheckinLink: "Avant l'arrivée",
    whenWelcome: "Après l'enregistrement",
    whenAccess: "Jour d'arrivée",
    whenArrival: "Jour d'arrivée",
    whenCheckout: "La veille du départ",
    whenReview: "Après le départ",
    // WhatsApp previews
    previewLead: "👋 Bonjour ! Je suis l'assistant virtuel de *{name}*.\n\nJe suis là pour vous aider avec votre réservation et répondre à vos questions.",
    previewConfirm: "Bonjour *Laura García* 👋\n\nVotre réservation à *{name}* est confirmée ✅\n\nCode de réservation : *6233Q1VC5*\nDates : *05/06/2026* – *07/06/2026* 📅\n\nVia ce WhatsApp, vous pouvez demander votre lien de check-in en ligne et également recevoir les instructions d'arrivée.\nSi vous avez besoin d'aide avant ou pendant votre séjour, écrivez-nous ici 💬",
    previewWelcome: "👋 Bienvenue à *{name}* !\n\nMerci d'avoir finalisé votre enregistrement. Voici toutes les informations concernant votre séjour.",
    previewAccess: "🔒🔑 *Code d'accès · {name}*\n\nVotre code est : *58117*\n\nValable pendant tout votre séjour.",
    previewArrival: "🏡 *Instructions d'arrivée*\n\nÀ votre arrivée, dirigez-vous vers l'entrée principale de l'hébergement. 🔑\n\nProfitez bien de votre séjour ! ✨",
    previewCheckout: "Bonjour 👋\n\nPetit rappel : *votre séjour se termine demain* à *{name}*.\n\n🕚 L'heure limite de check-out est *12:00*.\n\nBon voyage ! 😊",
    previewReview: "⭐ Comment s'est passé votre séjour à *{name}* ?\n\nNous aimerions beaucoup avoir votre avis. Laissez-nous votre avis ici 👉 …",
    previewLeadNoWaba: "📲 *Activez votre agent IA* pour gérer les nouvelles réservations via WhatsApp en connectant votre propre numéro.\n\nAinsi, l'assistant répondra aux personnes qui ne sont pas encore clientes, en répondant à leurs questions sur vos hébergements et en les guidant vers la réservation.",
    // Full "Check-in link" conversation
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Elige tu idioma · Choose your language",
    chatCheckinLink: "*Merci* 👋 Voici votre lien pour effectuer le check-in. 😎\n\nhttps://guest.wacheckin.com/…",
    // Access messages (locks)
    lockLabelFallback: "Entrée",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nVotre code d'accès est : *58117*\n\nValable pendant tout votre séjour.",
    lockNone: "🔑 *{label} · {name}*\n\nLa boîte à clés s'ouvre avec le code : *{code}*\n\nVous y trouverez les clés de l'hébergement.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nLe code de la serrure est : *{code}*\n\nUtilisez-le pour ouvrir la porte.",
    // Departure message (fallback)
    checkoutFallback: "Bonjour *María* 👋\n\nPetit rappel : votre séjour se termine demain à *{name}*.\n\n🕚 L'heure limite de check-out est *{time}*.\n\nMerci beaucoup pour votre séjour. Bon voyage ! 😊",
  },

  // ListingIcalPanel.vue — iCal sync panel
  icalPanel: {
    eyebrow: "Calendrier iCal",
    heading: "Synchronisation iCal",
    pageDesc: "Exportez vos réservations vers d'autres plateformes et importez des calendriers externes pour bloquer automatiquement des dates sur votre annonce.",
    loading: "Chargement de la configuration…",
    exportLabel: "Votre lien iCal (export)",
    exportDesc: "Copiez ce lien et collez-le dans Airbnb, Booking.com ou toute plateforme prenant en charge la synchronisation iCal. Elles récupéreront vos réservations automatiquement.",
    copied: "Copié",
    copy: "Copier",
    tipAllUnits: "Ce lien inclut les réservations de <strong>toutes les unités</strong> de l'annonce.",
    tipHotelRooms: "Chaque <strong>chambre physique</strong> a son propre lien. Connectez-le dans Airbnb/Booking pour cette chambre précise et seules les réservations de CETTE chambre seront exportées.",
    importLabel: "Calendriers externes (import)",
    syncing: "Synchronisation…",
    syncAll: "Tout synchroniser",
    importDesc: "Collez les URL iCal de vos autres plateformes (Airbnb, Booking.com, etc.) et Wacheckin bloquera automatiquement ces dates sur votre calendrier.",
    lastSync: "Dernière synchronisation : {date}",
    delete: "Supprimer",
    empty: "Vous n'avez encore aucun calendrier externe lié.",
    addExternal: "Ajouter un calendrier externe",
    newExternal: "Nouveau calendrier externe",
    nameLabel: "Nom du calendrier",
    namePlaceholder: "ex. Airbnb - Apt 1",
    physicalRoom: "Chambre physique",
    listingUnit: "Unité de l'annonce",
    selectRoomPlaceholder: "Sélectionnez une chambre…",
    selectUnitPlaceholder: "Sélectionnez une unité…",
    urlLabel: "URL du calendrier iCal",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveSync: "Enregistrer et synchroniser",
    defaultGroup: "Chambres",
    toastLoadError: "Impossible de charger la configuration iCal.",
    toastSelectUnit: "Sélectionnez une chambre / unité.",
    toastAdded: "Calendrier ajouté et synchronisé avec succès.",
    toastAddError: "Erreur lors de l'ajout du calendrier.",
    deleteConfirm: 'Supprimer "{name}" et toutes ses réservations bloquées ?',
    toastDeleted: "Calendrier supprimé.",
    toastDeleteError: "Impossible de supprimer le calendrier.",
    toastSyncError: "Erreur de synchronisation.",
  },

  // ListingIcalModal.vue — iCal sync modal
  icalModal: {
    title: "Synchronisation iCal",
    loading: "Chargement de la configuration…",
    exportLabel: "Votre lien iCal (export)",
    exportDesc: "Copiez ce lien et collez-le dans Airbnb, Booking.com ou toute plateforme prenant en charge la synchronisation iCal. Elles récupéreront vos réservations automatiquement.",
    copied: "Copié",
    copy: "Copier",
    tipAllUnits: "Ce lien inclut les réservations de <strong>toutes les unités</strong> de l'annonce.",
    tipHotelRooms: "Chaque <strong>chambre physique</strong> a son propre lien. Connectez-le dans Airbnb/Booking pour cette chambre précise et seules les réservations de CETTE chambre seront exportées.",
    importLabel: "Calendriers externes (import)",
    syncing: "Synchronisation…",
    syncAll: "Tout synchroniser",
    importDesc: "Collez les URL iCal de vos autres plateformes (Airbnb, Booking.com, etc.) et Wacheckin bloquera automatiquement ces dates sur votre calendrier.",
    lastSync: "Dernière synchronisation : {date}",
    delete: "Supprimer",
    empty: "Vous n'avez encore aucun calendrier externe lié.",
    addExternal: "Ajouter un calendrier externe",
    newExternal: "Nouveau calendrier externe",
    nameLabel: "Nom du calendrier",
    namePlaceholder: "ex. Airbnb - Apt 1",
    physicalRoom: "Chambre physique",
    listingUnit: "Unité de l'annonce",
    selectRoomPlaceholder: "Sélectionnez une chambre…",
    selectUnitPlaceholder: "Sélectionnez une unité…",
    urlLabel: "URL du calendrier iCal",
    cancel: "Annuler",
    saveSync: "Enregistrer et synchroniser",
    defaultGroup: "Chambres",
    toastLoadError: "Impossible de charger la configuration iCal.",
    toastSelectUnit: "Sélectionnez une chambre / unité.",
    toastAdded: "Calendrier ajouté et synchronisé avec succès.",
    toastAddError: "Erreur lors de l'ajout du calendrier.",
    deleteConfirm: 'Supprimer "{name}" et toutes ses réservations bloquées ?',
    toastDeleted: "Calendrier supprimé.",
    toastDeleteError: "Impossible de supprimer le calendrier.",
    toastSyncError: "Erreur de synchronisation.",
  },
};